var _linearGradient, _path, _path2, _linearGradient2, _path3, _linearGradient3, _path4, _linearGradient4, _path5, _linearGradient5, _path6, _linearGradient6, _path7, _linearGradient7, _path8, _linearGradient8, _path9, _linearGradient9, _path10, _linearGradient10, _path11, _linearGradient11, _path12, _linearGradient12, _circle, _linearGradient13, _circle2, _linearGradient14, _path13, _linearGradient15, _path14, _linearGradient16, _path15, _linearGradient17, _path16, _linearGradient18, _path17, _linearGradient19, _path18, _linearGradient20, _path19, _linearGradient21, _path20, _linearGradient22, _path21, _linearGradient23, _path22, _linearGradient24, _path23, _linearGradient25, _path24, _linearGradient26, _path25, _linearGradient27, _path26, _linearGradient28, _path27, _linearGradient29, _path28, _linearGradient30, _path29, _linearGradient31, _path30, _linearGradient32, _path31, _linearGradient33, _path32, _linearGradient34, _path33, _linearGradient35, _path34, _linearGradient36, _path35, _linearGradient37, _path36, _linearGradient38, _path37, _linearGradient39, _circle3, _linearGradient40, _circle4, _linearGradient41, _circle5, _linearGradient42, _circle6, _linearGradient43, _path38, _linearGradient44, _path39, _path40, _linearGradient45, _path41;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalaryAdvances(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357",
    gradientUnits: "userSpaceOnUse",
    x1: 1047.862,
    y1: -13.591,
    x2: 1048.862,
    y2: -13.591
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M78.653 76.446H59.322M138.262 76.446H133.1M152.62 123.079v16.334H42.258v-16.334M152.62 123.079V75.911l-15.335-9.383"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M87.773 47.31L42.258 75.911v47.168M107.513 84.825s3.733.915 4.986-1.955c1.253-2.871-1.881-5.157-1.881-5.157L101.71 82.7M104.816 75.587s-3.733-.915-4.986 1.955c-1.253 2.871 1.881 5.157 1.881 5.157M115.418 84.246l-2.957-1.291M99.867 77.457l-2.956-1.291"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357",
    gradientUnits: "userSpaceOnUse",
    x1: 2448.046,
    y1: 2215.835,
    x2: 2458.161,
    y2: 2215.835,
    gradientTransform: "rotate(-66.442 -350.748 2939.712)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.513 84.825s3.733.915 4.986-1.955c1.253-2.871-1.881-5.157-1.881-5.157L101.71 82.7",
    fill: "none",
    stroke: "url(#SVGID_1_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357",
    gradientUnits: "userSpaceOnUse",
    x1: 2448.046,
    y1: 2215.835,
    x2: 2458.161,
    y2: 2215.835,
    gradientTransform: "rotate(-66.442 -350.748 2939.712)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M104.816 75.587s-3.733-.915-4.986 1.955c-1.253 2.871 1.881 5.157 1.881 5.157",
    fill: "none",
    stroke: "url(#SVGID_2_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357",
    gradientUnits: "userSpaceOnUse",
    x1: 2448.046,
    y1: 2215.835,
    x2: 2458.161,
    y2: 2215.835,
    gradientTransform: "rotate(-66.442 -350.748 2939.712)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_3_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M115.418 84.246l-2.957-1.291"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357",
    gradientUnits: "userSpaceOnUse",
    x1: 2448.046,
    y1: 2215.835,
    x2: 2458.161,
    y2: 2215.835,
    gradientTransform: "rotate(-66.442 -350.748 2939.712)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_4_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M99.867 77.457l-2.956-1.291"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357",
    gradientUnits: "userSpaceOnUse",
    x1: 3557.662,
    y1: 2530.815,
    x2: 3561.014,
    y2: 2530.815,
    gradientTransform: "rotate(23.584 7708.158 -6920.627)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_5_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M117.256 98.595l14.026-34.255"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357",
    gradientUnits: "userSpaceOnUse",
    x1: 3523.956,
    y1: 2537.078,
    x2: 3526.456,
    y2: 2537.078,
    gradientTransform: "rotate(23.584 7708.158 -6920.627)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_6_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M80.573 96.249l19.819-45.396"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357",
    gradientUnits: "userSpaceOnUse",
    x1: 3531.05,
    y1: 2505.218,
    x2: 3553.061,
    y2: 2505.218,
    gradientTransform: "rotate(23.584 7708.158 -6920.627)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_7_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M127.613 54.998l-17.882-7.807"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357",
    gradientUnits: "userSpaceOnUse",
    x1: 3523.956,
    y1: 2508.765,
    x2: 3533.55,
    y2: 2508.765,
    gradientTransform: "rotate(23.584 7708.158 -6920.627)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M100.392 50.853a7.095 7.095 0 009.339-3.663",
    fill: "none",
    stroke: "url(#SVGID_8_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357",
    gradientUnits: "userSpaceOnUse",
    x1: 3523.956,
    y1: 2564.556,
    x2: 3533.245,
    y2: 2564.556,
    gradientTransform: "rotate(23.584 7708.158 -6920.627)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M80.573 96.249c3.589 1.567 4.681 5.592 4.053 7.685",
    fill: "none",
    stroke: "url(#SVGID_9_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357",
    gradientUnits: "userSpaceOnUse",
    x1: 3550.561,
    y1: 2508.765,
    x2: 3560.162,
    y2: 2508.765,
    gradientTransform: "rotate(23.584 7708.158 -6920.627)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M127.613 54.998a7.097 7.097 0 003.669 9.342",
    fill: "none",
    stroke: "url(#SVGID_10_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357",
    gradientUnits: "userSpaceOnUse",
    x1: 2471.931,
    y1: 2215.583,
    x2: 2480.558,
    y2: 2215.583,
    gradientTransform: "rotate(-66.442 -350.748 2939.712)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 115.182,
    cy: 58.893,
    r: 3.064,
    fill: "none",
    stroke: "url(#SVGID_11_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357",
    gradientUnits: "userSpaceOnUse",
    x1: 2425.258,
    y1: 2215.559,
    x2: 2433.885,
    y2: 2215.559,
    gradientTransform: "rotate(-66.442 -350.748 2939.712)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.507,
    cy: 101.667,
    r: 3.064,
    fill: "none",
    stroke: "url(#SVGID_12_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357",
    gradientUnits: "userSpaceOnUse",
    x1: 2423.545,
    y1: 2215.627,
    x2: 2492.248,
    y2: 2215.627,
    gradientTransform: "rotate(-66.442 -350.748 2939.712)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_13_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M125.233 93.89l16.848-39.363-42.189-18.394-26.451 60.688"
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357",
    gradientUnits: "userSpaceOnUse",
    x1: 2421.496,
    y1: 2215.627,
    x2: 2492.248,
    y2: 2215.627,
    gradientTransform: "rotate(-66.442 -350.748 2939.712)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M107.513 84.825s3.733.915 4.986-1.955c1.253-2.871-1.881-5.157-1.881-5.157L101.71 82.7",
    fill: "none",
    stroke: "url(#SVGID_14_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357",
    gradientUnits: "userSpaceOnUse",
    x1: 2421.496,
    y1: 2215.627,
    x2: 2492.248,
    y2: 2215.627,
    gradientTransform: "rotate(-66.442 -350.748 2939.712)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M104.816 75.587s-3.733-.915-4.986 1.955c-1.253 2.871 1.881 5.157 1.881 5.157",
    fill: "none",
    stroke: "url(#SVGID_15_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357",
    gradientUnits: "userSpaceOnUse",
    x1: 2421.496,
    y1: 2215.627,
    x2: 2492.248,
    y2: 2215.627,
    gradientTransform: "rotate(-66.442 -350.748 2939.712)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_16_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M115.418 84.246l-2.957-1.291"
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357",
    gradientUnits: "userSpaceOnUse",
    x1: 2421.496,
    y1: 2215.627,
    x2: 2492.248,
    y2: 2215.627,
    gradientTransform: "rotate(-66.442 -350.748 2939.712)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_17_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M99.867 77.457l-2.956-1.291"
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357",
    gradientUnits: "userSpaceOnUse",
    x1: 2421.496,
    y1: 2215.627,
    x2: 2492.248,
    y2: 2215.627,
    gradientTransform: "rotate(-66.442 -350.748 2939.712)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M107.513 84.825s3.733.915 4.986-1.955c1.253-2.871-1.881-5.157-1.881-5.157L101.71 82.7",
    fill: "none",
    stroke: "url(#SVGID_18_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357",
    gradientUnits: "userSpaceOnUse",
    x1: 2421.496,
    y1: 2215.627,
    x2: 2492.248,
    y2: 2215.627,
    gradientTransform: "rotate(-66.442 -350.748 2939.712)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M104.816 75.587s-3.733-.915-4.986 1.955c-1.253 2.871 1.881 5.157 1.881 5.157",
    fill: "none",
    stroke: "url(#SVGID_19_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357",
    gradientUnits: "userSpaceOnUse",
    x1: 2421.496,
    y1: 2215.627,
    x2: 2492.248,
    y2: 2215.627,
    gradientTransform: "rotate(-66.442 -350.748 2939.712)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_20_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M115.418 84.246l-2.957-1.291"
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357",
    gradientUnits: "userSpaceOnUse",
    x1: 2421.496,
    y1: 2215.627,
    x2: 2492.248,
    y2: 2215.627,
    gradientTransform: "rotate(-66.442 -350.748 2939.712)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_21_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M99.867 77.457l-2.956-1.291"
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357",
    gradientUnits: "userSpaceOnUse",
    x1: 2421.496,
    y1: 2215.627,
    x2: 2492.248,
    y2: 2215.627,
    gradientTransform: "rotate(-66.442 -350.748 2939.712)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M107.513 84.825s3.733.915 4.986-1.955c1.253-2.871-1.881-5.157-1.881-5.157L101.71 82.7",
    fill: "none",
    stroke: "url(#SVGID_22_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357",
    gradientUnits: "userSpaceOnUse",
    x1: 2421.496,
    y1: 2215.627,
    x2: 2492.248,
    y2: 2215.627,
    gradientTransform: "rotate(-66.442 -350.748 2939.712)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M104.816 75.587s-3.733-.915-4.986 1.955c-1.253 2.871 1.881 5.157 1.881 5.157",
    fill: "none",
    stroke: "url(#SVGID_23_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357",
    gradientUnits: "userSpaceOnUse",
    x1: 2421.496,
    y1: 2215.627,
    x2: 2492.248,
    y2: 2215.627,
    gradientTransform: "rotate(-66.442 -350.748 2939.712)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_24_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M115.418 84.246l-2.957-1.291"
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357",
    gradientUnits: "userSpaceOnUse",
    x1: 2421.496,
    y1: 2215.627,
    x2: 2492.248,
    y2: 2215.627,
    gradientTransform: "rotate(-66.442 -350.748 2939.712)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_25_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M99.867 77.457l-2.956-1.291"
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357",
    gradientUnits: "userSpaceOnUse",
    x1: 2421.496,
    y1: 2215.627,
    x2: 2492.248,
    y2: 2215.627,
    gradientTransform: "rotate(-66.442 -350.748 2939.712)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_26_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M117.256 98.595l14.026-34.255"
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357",
    gradientUnits: "userSpaceOnUse",
    x1: 2421.496,
    y1: 2215.627,
    x2: 2492.248,
    y2: 2215.627,
    gradientTransform: "rotate(-66.442 -350.748 2939.712)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_27_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M117.256 98.595l14.026-34.255"
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357",
    gradientUnits: "userSpaceOnUse",
    x1: 2421.496,
    y1: 2215.627,
    x2: 2492.248,
    y2: 2215.627,
    gradientTransform: "rotate(-66.442 -350.748 2939.712)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_28_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M80.573 96.249l19.819-45.396"
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357",
    gradientUnits: "userSpaceOnUse",
    x1: 2421.496,
    y1: 2215.627,
    x2: 2492.248,
    y2: 2215.627,
    gradientTransform: "rotate(-66.442 -350.748 2939.712)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_29_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M80.573 96.249l19.819-45.396"
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357",
    gradientUnits: "userSpaceOnUse",
    x1: 2421.496,
    y1: 2215.627,
    x2: 2492.248,
    y2: 2215.627,
    gradientTransform: "rotate(-66.442 -350.748 2939.712)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_30_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M127.613 54.998l-17.882-7.807"
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357",
    gradientUnits: "userSpaceOnUse",
    x1: 2421.496,
    y1: 2215.627,
    x2: 2492.248,
    y2: 2215.627,
    gradientTransform: "rotate(-66.442 -350.748 2939.712)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_31_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M127.613 54.998l-17.882-7.807"
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357",
    gradientUnits: "userSpaceOnUse",
    x1: 2421.496,
    y1: 2215.627,
    x2: 2492.248,
    y2: 2215.627,
    gradientTransform: "rotate(-66.442 -350.748 2939.712)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M100.392 50.853a7.095 7.095 0 009.339-3.663",
    fill: "none",
    stroke: "url(#SVGID_32_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357",
    gradientUnits: "userSpaceOnUse",
    x1: 2421.496,
    y1: 2215.627,
    x2: 2492.248,
    y2: 2215.627,
    gradientTransform: "rotate(-66.442 -350.748 2939.712)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M100.392 50.853a7.095 7.095 0 009.339-3.663",
    fill: "none",
    stroke: "url(#SVGID_33_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357",
    gradientUnits: "userSpaceOnUse",
    x1: 2421.496,
    y1: 2215.627,
    x2: 2492.248,
    y2: 2215.627,
    gradientTransform: "rotate(-66.442 -350.748 2939.712)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M80.573 96.249c3.589 1.567 4.681 5.592 4.053 7.685",
    fill: "none",
    stroke: "url(#SVGID_34_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357",
    gradientUnits: "userSpaceOnUse",
    x1: 2421.496,
    y1: 2215.627,
    x2: 2492.248,
    y2: 2215.627,
    gradientTransform: "rotate(-66.442 -350.748 2939.712)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M80.573 96.249c3.589 1.567 4.681 5.592 4.053 7.685",
    fill: "none",
    stroke: "url(#SVGID_35_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357",
    gradientUnits: "userSpaceOnUse",
    x1: 2421.496,
    y1: 2215.627,
    x2: 2492.248,
    y2: 2215.627,
    gradientTransform: "rotate(-66.442 -350.748 2939.712)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M127.613 54.998a7.097 7.097 0 003.669 9.342",
    fill: "none",
    stroke: "url(#SVGID_36_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357",
    gradientUnits: "userSpaceOnUse",
    x1: 2421.496,
    y1: 2215.627,
    x2: 2492.248,
    y2: 2215.627,
    gradientTransform: "rotate(-66.442 -350.748 2939.712)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M127.613 54.998a7.097 7.097 0 003.669 9.342",
    fill: "none",
    stroke: "url(#SVGID_37_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357",
    gradientUnits: "userSpaceOnUse",
    x1: 2421.496,
    y1: 2215.627,
    x2: 2492.248,
    y2: 2215.627,
    gradientTransform: "rotate(-66.442 -350.748 2939.712)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 115.182,
    cy: 58.893,
    r: 3.064,
    fill: "none",
    stroke: "url(#SVGID_38_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357",
    gradientUnits: "userSpaceOnUse",
    x1: 2421.496,
    y1: 2215.627,
    x2: 2492.248,
    y2: 2215.627,
    gradientTransform: "rotate(-66.442 -350.748 2939.712)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 115.182,
    cy: 58.893,
    r: 3.064,
    fill: "none",
    stroke: "url(#SVGID_39_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357",
    gradientUnits: "userSpaceOnUse",
    x1: 2421.496,
    y1: 2215.627,
    x2: 2492.248,
    y2: 2215.627,
    gradientTransform: "rotate(-66.442 -350.748 2939.712)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.507,
    cy: 101.667,
    r: 3.064,
    fill: "none",
    stroke: "url(#SVGID_40_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357",
    gradientUnits: "userSpaceOnUse",
    x1: 2421.496,
    y1: 2215.627,
    x2: 2492.248,
    y2: 2215.627,
    gradientTransform: "rotate(-66.442 -350.748 2939.712)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.507,
    cy: 101.667,
    r: 3.064,
    fill: "none",
    stroke: "url(#SVGID_41_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357",
    gradientUnits: "userSpaceOnUse",
    x1: 2421.496,
    y1: 2215.627,
    x2: 2492.248,
    y2: 2215.627,
    gradientTransform: "rotate(-66.442 -350.748 2939.712)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_42_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M125.233 93.89l16.848-39.363-42.189-18.394-26.451 60.688"
  })), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357",
    gradientUnits: "userSpaceOnUse",
    x1: 2421.496,
    y1: 2215.627,
    x2: 2492.248,
    y2: 2215.627,
    gradientTransform: "rotate(-66.442 -350.748 2939.712)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_43_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M125.233 93.89l16.848-39.363-42.189-18.394-26.451 60.688"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M152.62 75.911L135.084 87.84l-16.096 10.935-.951.643-14.515 9.873-5.859 3.986-.644.433-6.404-4.419-14.264-9.845-17.242-11.9-16.851-11.635"
  })), _linearGradient45 || (_linearGradient45 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357",
    gradientUnits: "userSpaceOnUse",
    x1: 558.898,
    y1: 211.804,
    x2: 590.938,
    y2: 163.234,
    gradientTransform: "rotate(-9.858 -376.49 2980.19)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_44_5c6eb9e8ee816ed80154683fd1ed3c0e64dd2318e824aa3f0ef75bad5ea57357)",
    strokeWidth: 2.172,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M97.104 41.594l-6.71-2.471-15.428 53.925"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalaryAdvances);
export default __webpack_public_path__ + "static/media/salaryAdvances.d86c74cd469164bf21465d1f30b49347.svg";
export { ForwardRef as ReactComponent };